export const margin = 6

// Z-Indexes
export const modalZIndex = 2147483646
export const menuZIndex = 2000
export const headerZIndex = 1000
export const belowHeaderZIndex = headerZIndex - 1
export const aboveHeaderZIndex = headerZIndex + 2

export const fontFamily = {
    title: 'nexablack, sans-serif',
    body: 'interface, Helvetica Neue, helvetica, sans-serif;',
}

export const desktopWidth = 1040
